/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/qnt.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const qntPage: ICoinPageData = {
  title: 'coin_777',
  description: 'coin_778',
  // description: 'coin_779',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Quant (QNT)' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_780',
        answer: 'coin_781',
      },
      {
        title: 'coin_782',
        answer: 'coin_783',
      },
      {
        title: 'coin_784',
        answer: 'coin_785',
      },
      {
        title: 'coin_786',
        answer: 'coin_787',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Quant (QNT)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_788',
        text: ['coin_790'],
      },
      {
        title: 'coin_789',
        text: ['coin_791'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
